// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 自定义样式 */
[data-v-c3d46006] .detail .van-cell {
  background-color: transparent;
  padding: 0.25rem 1rem;
}
[data-v-c3d46006] .detail .van-cell::after {
  border-bottom: none;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
